import { render, staticRenderFns } from "./ChangePriority.vue?vue&type=template&id=b48750c2&scoped=true"
import script from "./ChangePriority.vue?vue&type=script&lang=js"
export * from "./ChangePriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48750c2",
  null
  
)

export default component.exports